import {useQuery} from "@tanstack/react-query";
import * as api from "../../api";

export const useExportTaskPollingQuery = ({exportTaskId}) => {
    return useQuery({
        queryKey: ['exportTask', exportTaskId],
        queryFn: () => api.ExportTask.getExportTask(exportTaskId),
        enabled: exportTaskId !== null && exportTaskId !== undefined,
        keepPreviousData: true,
        refetchInterval: (data) => {
            if (data?.status === 'PENDING' || data?.status === 'IN_PROGRESS') {
                return 5000; // refetch every 5 seconds if the task is still in progress
            }
            return false; // stop refetching if the task is completed or failed
        },
    });
}